<template>
  <div class="card">
    <div class="card-header"><h2 style="font-size: 20px;">Customer Information</h2></div>
    <div class="card-body">
      <b-row row-justify="center">
        <b-col cols="12" md="6" lg="3">
          <BaseTextInput v-model="profile.name.firstName"
                         :v="$v.profile.name.firstName"
                         slug="firstName"
                         label="First name"
                         setId="firstName"
                         :plaintext="hasProfile"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <BaseTextInput v-model="profile.name.middleName"
                         :v="$v.profile.name.middleName"
                         slug="middleName"
                         label="Middle name"
                         setId="middleName"
                         :plaintext="hasProfile"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <BaseTextInput v-model="profile.name.lastName"
                         :v="$v.profile.name.lastName"
                         slug="lastName"
                         label="Last name"
                         setId="lastName"
                         :plaintext="hasProfile"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" lg="3">
          <BaseMaskedTextInput v-model="profile.phone"
                               :v="$v.profile.phone"
                               slug="phone"
                               label="Phone number"
                               setId="phone"
                               mask="(###)###-####"
                               :plaintext="noPhone"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3">
          <BaseCheckboxInput label="I do not have a phone number"
                             v-model="noPhone"
                             :v="$v.noPhone"
                             slug="noPhone"
                             setId="noPhone"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="6" lg="3">
          <BaseTextInput v-model="profile.email"
                         :v="$v.profile.email"
                         slug="email"
                         label="Email address"
                         setId="email"
                         :required="hasDataFile"
                         :messages="opts.emailMessage"
                         :plaintext="noEmail"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="!hasDataFile">
          <BaseCheckboxInput label="I do not have an email address"
                             v-model="noEmail"
                             :v="$v.noEmail"
                             slug="noEmail"
                             setId="noEmail"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h5>Contact Address</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="4">
          <BaseTextInput v-model="profile.address.streetAddress"
                         :v="$v.profile.address.streetAddress"
                         slug="streetAddress"
                         setId="streetAddress"
                         label="Address Line 1"
                         maxlength="90"
          />
        </b-col>
        <b-col cols="12" lg="4">
          <BaseTextInput v-model="profile.address.poBox"
                         :v="$v.profile.address.poBox"
                         slug="poBox"
                         setId="poBox"
                         label="Address Line 2"
                         maxlength="90"
          />
        </b-col>
<!--        <b-col cols="12" lg="4">-->
<!--          <BaseCheckboxInput label="International address"-->
<!--                             v-model="profile.address.international"-->
<!--                             :v="$v.profile.address.international"-->
<!--                             slug="international"-->
<!--                             setId="international"-->
<!--                             legend="Address outside the US"-->
<!--          />-->
<!--        </b-col>-->
      </b-row>
      <b-row>
        <b-col cols="12" md="6" lg="3" v-if="profile.address.international || !isMn">
          <BaseTextInput v-model="profile.address.city"
                         :v="$v.profile.address.city"
                         slug="addressCity"
                         set-id="addressCity"
                         label="City"
                         maxLength="100"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="!profile.address.international && isMn">
          <BaseSearchableSelector v-model="profile.address.mnCity"
                                  :v="$v.profile.address.mnCity"
                                  label="City"
                                  :options = cityOptions
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="!profile.address.international">
          <BaseSelector v-model="profile.address.state"
                        :v="$v.profile.address.state"
                        label="State"
                        setId="addressState"
                        slug="addressState"
                        :options=opts.stateOptions
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="!profile.address.international">
          <BaseMaskedTextInput v-model="profile.address.zip"
                               :v="$v.profile.address.zip"
                               slug="zip"
                               setId="zip"
                               label="Zip code"
                               mask="#####-####"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="profile.address.international">
          <BaseTextInput v-model="profile.address.state"
                         :v="$v.profile.address.state"
                         slug="addressState"
                         setId="addressState"
                         label="State/Province/District"
                         maxlength="28"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="profile.address.international">
          <BaseTextInput v-model="profile.address.zip"
                         :v="$v.profile.address.zip"
                         slug="zip"
                         setId="zip"
                         label="Postal code/ZIP code"
                         maxlength="9"
          />
        </b-col>
        <b-col cols="12" md="6" lg="3" v-if="profile.address.international">
          <BaseSelector v-model="profile.address.country"
                        :v="$v.profile.address.country"
                        label="Country"
                        slug="addressCountry"
                        setId="addressCountry"
                        textField="description"
                        valueField="code"
                        :options=countryOptions
          />
        </b-col>
      </b-row>
    </div>
  </div>

</template>
<script>

import { commonOptions} from "@/mixins/commonOptions";
import {toastService} from "@/mixins/toastService";
import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
import BaseMaskedTextInput from '@/components/templates/input/BaseMaskedTextInput.vue'
import {required, email, requiredIf, maxLength} from 'vuelidate/lib/validators'
import axiosRetry from 'axios-retry'
import axios from "axios"
import LocalStorageService from "@/common/LocalStorageService";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

const localStorageService = LocalStorageService.getService();


export default {
  data: () => {
    return {
      opts: {
        emailMessage: {
          required: 'You must enter a valid email address to receive data reports'
        }
      },
      hasProfile: false,
      hasDob: false,
      noPhone: false,
      noEmail: false,
    }
  },
  props: {
    order: [Object],
    profile: [Object],
    cityOptions: [Array],
    products: [Array],
    countryOptions: [Array],
    hasDataFile: [Boolean],
  },
  components: {
    BaseMaskedTextInput,
    BaseTextInput,
  },
  mixins: [
      commonOptions,
      toastService
  ],
  validations() {
    return {
      profile: {
        name: {
          lastName: { required: requiredIf(function() {
              return !this.hasProfile
            })},
          firstName: { required: requiredIf(function() {
              return !this.hasProfile
            })},
          middleName: { required: false },
        },
        phone: { required: requiredIf(function() {
            return !this.noPhone && !this.hasProfile
          })
        },
        email: { required:requiredIf(function() {
            return !this.noEmail && !this.hasProfile
          }),
          email
        },
        address: {
          streetAddress: {
            required: requiredIf(function() {
              return !this.hasProfile
            }),
            maxLength: maxLength(90),
          },
          poBox: {
            required: false,
            maxLength: maxLength(90),
          },
          city: { required: requiredIf(function(){
            return (this.profile?.address?.international || this.profile?.address?.state !== 'MN') && !this.hasProfile
          }) },
          mnCity: { required: requiredIf(function(){
            return this.profile?.address?.state === 'MN' && !this.profile?.address?.international && !this.hasProfile
          }) },
          state: { required: requiredIf(function() {
              return !this.hasProfile && !this.profile.address.international
            }) },
          zip: { required: requiredIf(function() {
              return !this.hasProfile
            }),
            maxLength: 10
          },
          country: { required : requiredIf(function() {
              return this.profile.address.international
            }) },
          addressType: { required },
          international: { required : false},
        }
      },
      noPhone: { required: false },
      noEmail: { required: false },
      form: [ 'profile' ]
    }
  },
  mounted() {
  },
  computed: {
    isMn() {
      return this.profile?.address?.state === 'MN'
    },
    stateVal() {
      return this.profile?.address?.state
    },
  },
  watch: {
    noPhone() {
      if (this.noPhone) {
        this.profile.phone = null
      }
    },
    noEmail() {
      if (this.noEmail) {
        this.profile.email = null
      }
    },
    stateVal() {
      if (!this.profile.address) {
        this.profile.address = {
              streetAddress: null,
              poBox: null,
              city: null,
              mnCity: null,
              state: null,
              zip: null,
              country: "US",
              addressType: "CONTACT",
              international: false,
        }
      }
      if(this.isMn) {
        let exists = this.cityOptions.filter(c => c.label.toUpperCase() === this.profile.address.city?.toUpperCase())
        if (exists.length > 0) {
          this.profile.address.mnCity = exists[0]
        } else {
          this.profile.address.mnCity = null
        }
        this.profile.address.city = null
      } else if (!this.isMn && this.profile?.address?.mnCity && this.profile?.address?.mnCity?.label) {
        this.profile.address.city = this.profile.address.mnCity.label
        this.profile.address.mnCity = null
      }
    },
    'profile.address.international'(value) {
      if (!this.profile.address) {
        this.profile.address = {
          streetAddress: null,
          poBox: null,
          city: null,
          mnCity: null,
          state: null,
          zip: null,
          country: 'US',
          addressType: "CONTACT",
          international: false,
        }
      }
      if(value){
        this.profile.address.country = null;
      } else {
        this.profile.address.country = 'US';
      }
      this.profile.address.state = null;
      this.profile.address.mnCity = null;
      this.profile.address.city = null;
      this.profile.address.zip = null;
    },
    profile() {
      if(this.profile.address) {
        this.profile.address.addressType = 'CONTACT'
      }
      if (this.$keycloak.authenticated) {
        this.hasProfile = true
      }
    }
  },
  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid, 'customer')
      return isValid
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.profile.orders = [{id: localStorageService.getOrderNumber()}]
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/profile/update`, this.profile)
              .then(response=> {
                this.$emit('on-submit')
                toastService.showRootToast("Customer Information Submitted", "Customer Information has been updated" , "success", this.$root)
              })
              .catch(err => {
                toastService.showRootToast("Error", "An error has occurred, please confirm the accuracy of your Customer Information" , "danger", this.$root)
              })
    },
  },
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
